import axios from "axios";
import { API, setToken } from "@/lib/api";
import { setPortalToken } from "@/lib/portalApi";

const ACC = "bb_accounts";
const ACTIVE = "bb_active";
const OWNER = "bb_owner_token";

export const getAccounts = () => { try { return JSON.parse(localStorage.getItem(ACC) || "[]"); } catch { return []; } };
export const getActive = () => Number(localStorage.getItem(ACTIVE) || 0);
export const saveAccounts = (list) => localStorage.setItem(ACC, JSON.stringify(list));
export const getOwnerToken = () => localStorage.getItem(OWNER);

export const accountLabel = (a) => (a.kind === "owner" ? "Platform Owner" : `${a.business_name} — ${a.role}`);
export const homeOf = (a) => (a.kind === "owner" ? "/owner" : a.kind === "portal" ? "/portal" : "/");

export function activate(list, i) {
  const a = list[i];
  saveAccounts(list);
  localStorage.setItem(ACTIVE, String(i));
  if (a.kind === "owner") localStorage.setItem(OWNER, a.access_token);
  if (a.kind === "portal") setPortalToken(a.access_token);
  if (a.kind === "employee") setToken(a.access_token);
  window.location.href = homeOf(a);
}

export function logoutAll() {
  [ACC, ACTIVE, OWNER].forEach((k) => localStorage.removeItem(k));
  setToken(null);
  setPortalToken(null);
  window.location.href = "/login";
}

export const ownerApi = axios.create({ baseURL: API });
ownerApi.interceptors.request.use((c) => { const t = getOwnerToken(); if (t) c.headers.Authorization = `Bearer ${t}`; return c; });
ownerApi.interceptors.response.use((r) => r, (e) => {
  if (e.response?.status === 401) { localStorage.removeItem(OWNER); window.location.href = "/login"; }
  return Promise.reject(e);
});
